module.exports = __webpack_public_path__ + "img/jordskokkesuppe.579cb1c9.jpg";